import { render, staticRenderFns } from "./SkillsSelector.vue?vue&type=template&id=04419e09&"
import script from "./SkillsSelector.vue?vue&type=script&lang=js&"
export * from "./SkillsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports